// extracted by mini-css-extract-plugin
export default {"footer":"footerStyles_footer__nW5a-"};